import styled from "styled-components";

interface ICardDiagnosticProps {
    borderBottom?: boolean;
}

export const CardDiagnostic = styled.div<ICardDiagnosticProps>`
    padding: 5px 10px;
    border-bottom: ${props => props.borderBottom ? '1px solid #bbb' : 'none'};
`

export const TableDiagnostic = styled.table`
`;

export const TableBodyDiagnostic = styled.tbody`
`;

export const TableRowDiagnostic = styled.tr`
`;

interface ITableColumnDiagnosticProps {
    width?: string;
}

export const TableColumnDiagnostic = styled.td<ITableColumnDiagnosticProps>`
    width: ${props => props.width || 'auto'};
`;